import axios from 'axios'
import Vue from 'vue'
var vue = new Vue();
const api = {
    async get(url) {
        try {
            let res = await axios.get(url)
            res = res.data
            return new Promise((resolve) => {
                if (res.code == 1000) {
                    resolve(res)
                } else if (res.code == 403) {
                    console.log(res.code);
                    window.sessionStorage.clear()
                    Vue.prototype.$message.error("请先进行登录");
                } else {
                    // resolve(res)
                }
            })
        } catch (err) {

        }
    },
    async post(url, data) {
        try {
            let res = await axios.post(url, data)
            res = res.data
            return new Promise((resolve, reject) => {
                if (res.code == 1000) {
                    resolve(res)
                } else if (res.code == 403) {
                    window.sessionStorage.clear()
                    Vue.prototype.$message.error("请先进行登录");
                } else {
                    resolve(res)
                }
            })
        } catch (err) {

        }
    },
}
export { api }
